<template>
  <div v-if="listOf == 'submited'" class="modal fade" id="warning" tabindex="-1" aria-labelledby="warning" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-gradient-danger" id="warningModalHeader">
          <h5 class="modal-title" id="warningModalLabel"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <h4>آیا از حذف تیکت با عنوان زیر اطمینان دارید؟!</h4>
          <h4>{{ ticket.title }}</h4>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn bg-gradient-success" data-bs-dismiss="modal">خیر</button>
          <button type="button" class="btn bg-gradient-danger" data-bs-dismiss="modal"
            @click="deleteTicket">حذف</button>
        </div>
      </div>
    </div>
  </div>
  <div class="py-4 container-fluid">
    <div class="row">
      <ul class="nav nav-tabs nav-fill nav-tabs-styled" id="ticketTabs">
        <li class="nav-item">
          <button class="nav-link h-100" :class="currentTab?.key == 1 ? 'active' : ''" id="openTickets"
            @click="changeTab(1)">
            تیکت های باز
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link h-100" :class="currentTab?.key == 2 ? 'active' : ''" id="notSeenTickets"
            @click="changeTab(2)">
            دیده نشده
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link h-100" :class="currentTab?.key == 4 ? 'active' : ''" id="inProgressTickets"
            @click="changeTab(4)">
            درحال بررسی
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link h-100" :class="currentTab?.key == 9 ? 'active' : ''" id="CustomerResponsePendingTickets"
            @click="changeTab(9)">
            در انتظار پاسخ مشتری
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link h-100" :class="currentTab?.key == 5 ? 'active' : ''" id="answeredTickets"
            @click="changeTab(5)">
            پاسخ داده شده
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link h-100" :class="currentTab?.key == 6 ? 'active' : ''" id="closedTickets"
            @click="changeTab(6)">
            بسته شده
          </button>
        </li>
      </ul>
      <div class="card mb-4 tabbed">
        <div class="card-body px-0">
          <details :open="filtersAreOpen">
            <summary>
              <div class="card-header bg-gradient-light text-dark py-1">فیلترها</div>
            </summary>
            <body>
              <div class="row">
                <div class="col-md-4 col-6">
                  <label class="form-text" for="searchField">کد / عنوان / توضیح اولیه</label>
                  <input class="form-control" type="text" id="searchField" name="searchField"
                    v-model.trim="searchField" />
                </div>
                <div class="col-md-2 col-6">
                  <label for="section" class="form-text">اهمیت</label>
                  <vue-select v-model="selectedImportances" :options="importances" dir="rtl" label="value" multiple>
                    <template #no-options="{ search, searching, loading }">
                      موردی یافت نشد!
                    </template>
                  </vue-select>
                </div>
                <div class="col-md-2 col-6">
                  <label for="section" class="form-text">بخش هدف</label>
                  <vue-select v-model="selectedSections" :options="sections" dir="rtl" label="title" multiple
                    @click="getCompanySections()">
                    <template #no-options="{ search, searching, loading }">
                      موردی یافت نشد!
                    </template>
                  </vue-select>
                </div>
                <div class="col-md-2 col-6">
                  <label for="ticketLabel" class="form-text">برچسب‌ها</label>
                  <vue-select v-model="selectedTicketLabels" :options="ticketLabels" dir="rtl" label="title" multiple
                    @click="getTicketLabels()">
                    <template #no-options="{ search, searching, loading }">
                      موردی یافت نشد!
                    </template>
                  </vue-select>
                </div>
                <div v-if="currentTab?.key == 1 | currentTab?.key == 6" class="col-md-2 col-6">
                  <label for="section"
                    class="form-text">وضعیت</label>
                  <vue-select v-model="selectedStatuses"
                    :options="currentTab?.key == 6 ? statuses.slice(4) : statuses.slice(0, 3)" dir="rtl" label="value"
                    multiple>
                    <template #no-options="{ search, searching, loading }">
                      موردی یافت نشد!
                    </template>
                  </vue-select>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <label class="form-text" for="fromDate">تاریخ ایجاد از</label>
                  <date-picker id="createDateFrom" format="jYYYYjMMjDD" displayFormat="jYYYY/jMM/jDD"
                    v-model="fromDate" clearable editable />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <label class="form-text" for="toDate">تاریخ ایجاد تا</label>
                  <date-picker id="createDateFrom" format="jYYYYjMMjDD" displayFormat="jYYYY/jMM/jDD"
                    v-model="toDate" clearable editable />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <label class="form-text" for="fromAnsweredDate">تاریخ پاسخ به تیکت از</label>
                  <date-picker id="createDateFrom" format="jYYYYjMMjDD" displayFormat="jYYYY/jMM/jDD"
                    v-model="fromAnsweredDate" clearable editable />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <label class="form-text" for="fromAnsweredDate">تاریخ پاسخ به تیکت تا</label>
                  <date-picker id="createDateFrom" format="jYYYYjMMjDD" displayFormat="jYYYY/jMM/jDD"
                    v-model="toAnsweredDate" clearable editable />
                </div>
                <div v-if="isCompanyUser" class="col-md-3 col-6">
                  <label class="form-text" for="holdingCompanyTitle">مشتری</label>
                  <treeselect :key="'tLCustomerTreeselect' + treeselectKey" v-model="customerId" :multiple="false"
                    :placeholder="'انتخاب مشتری'" :showCount="true" noOptionsText="هنوز مشتری‌ای تعریف نشده است"
                    noResultsText="موردی یافت نشد" noChildrenText="این مشتری فاقد زیر مجموعه است"
                    :options="customers" />
                </div>
                <div v-if="isCompanyUser | listOf == 'all' | (listOf == 'bookmarked' & isAdmin)" class="col-md-3 col-6">
                  <label for="section" class="form-text">کاربر مشتری</label>
                  <vue-select v-model="selectedUsers" :options="users" dir="rtl" label="displayProp" multiple
                    @click="getUsersByCustomer()">
                    <template #no-options="{ search, searching, loading }">
                      موردی یافت نشد!
                    </template>
                  </vue-select>
                </div>
                <div>
                  <button class="btn btn-sm col-lg-2 col-md-3 mt-3 me-3 mb-0 bg-gradient-primary"
                    @click="activateFilters">
                    اعمال فیلترها
                  </button>
                  <button v-if="filtersAreActive"
                    class="btn btn-sm col-lg-2 col-md-3 mt-3 me-3 mb-0 bg-gradient-secondary" @click="deactivateFilters">
                    عدم اعمال فیلترها
                  </button>
                  <button class="btn btn-sm col-lg-2 col-md-3 mt-3 me-3 mb-0 bg-gradient-warning" @click="clearFilters">
                    خالی کردن فیلترها
                  </button>
                </div>
              </div>
            </body>
          </details>
          <hr class="horizontal dark" />
          <div class="mb-1 me-1 col-md-2 col-sm-6">
            <select v-if="listOf != 'all'" class="form-control" v-model="selectedSorting">
              <option v-for="so in sortOptions" :value="so.key">{{ so.value }}</option>
            </select>
          </div>
          <div class="table-responsive p-0">
            <table class="table table-striped table-sm table-styled">
              <thead id="tLTH">
                <tr>
                  <th scope="col"></th>
                  <th scope="col">#</th>
                  <th scope="col" class="text-nowrap">زمان ثبت</th>
                  <th scope="col">کد</th>
                  <th scope="col">عنوان</th>
                  <th v-if="isCompanyUser" scope="col">مجموعه</th>
                  <th v-if="isCompanyUser | listOf == 'all' | (listOf == 'bookmarked' & isAdmin)"
                    scope="col" class="text-nowrap">
                      کاربر درخواست کننده
                  </th>
                  <th scope="col" class="text-nowrap">بخش هدف</th>
                  <th scope="col">وضعیت</th>
                  <th scope="col">امکانات</th>
                </tr>
              </thead>
              <tbody>
                <tr></tr>
                <tr v-for="(t, index) in ticketList">
                  <td>
                    <fa-layers class="pointer" @click="ticketBookmarkToggle(t.id)">
                      <fa-icon class="c-yellow-600" icon="fas fa-bookmark" size="lg" />
                      <fa-icon :class="t.isBookmarked ? 'c-yellow-600' : 'text-white'" icon="fas fa-bookmark" transform="up-1" />
                    </fa-layers>
                  </td>
                  <td>
                    <span v-if="notifications.map(n => n.ticketId).indexOf(t.id) > -1" class="position-relative">
                      <span class="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle"></span>
                    </span>
                    <span class="pe-1">
                      {{ index + (pageIndex * pageSize) + 1 }}
                    </span>
                  </td>
                  <td>
                    {{ $filters.toDateString(t.createDate) }}
                    <br />
                    {{ $filters.toTimeString(t.createTime) }}
                  </td>
                  <td>{{ t.ticketCode }}</td>
                  <td>
                    <div class="d-flex flex-wrap align-items-center">
                      <div class="display-ruby">
                        <div v-if="t.ticketImportanceEnum > 0" class="table-importance p-1 mb-0 ms-2 h-0"
                          :class="t.ticketImportanceEnum > 1 ? 'bg-danger' : 'bg-warning'"
                          :title="t.ticketImportanceEnum == 1 ? 'سطح اهمیت متوسط' : 'سطح اهمیت بالا'">
                        </div>
                        <router-link :to="'/ticketDetails/' + t.id" class="text-not-hover-black ms-1">
                          {{ t.title }}
                        </router-link>
                      </div>
                      <div v-for="l in t.labels" class="chatbox-header-label text-nowrap fs-6 align-self-center my-0 mx-1 px-2 h-50">
                        {{ l.title }}
                      </div>
                    </div>
                  </td>
                  <td v-if="isCompanyUser">{{ t.createUser?.customerTitle ?? t.createUser?.companyTitle }}</td>
                  <td v-if="isCompanyUser | listOf == 'all' | (listOf == 'bookmarked' & isAdmin)" class="">
                    <div>{{ t.createUser?.firstName }} {{ t.createUser?.lastName }} - {{ t.createUser?.postTitle }}</div>
                    <div v-if="t.lastChangeUser" class="d-flex flex-column text-info">
                      <div>{{ t.lastChangeUser?.firstName }} {{ t.lastChangeUser?.lastName }} - {{ t.lastChangeUser?.postTitle }}</div>
                      <div>{{ $filters.toTimeString(t.lastChangeTime) }} - {{ $filters.toDateString(t.lastChangeDate) }}</div>
                    </div>
                  </td>
                  <td>{{ t.companySectionTitle }}</td>
                  <td>
                    <div class="status table-status m-0 p-1"
                      :class="t.ticketStatusHistories?.[0]?.ticketStatus?.ticketStatusEnum == 0 ? 'status-danger' :
                        t.ticketStatusHistories?.[0]?.ticketStatus?.ticketStatusEnum == 1 ? 'status-warning' :
                        t.ticketStatusHistories?.[0]?.ticketStatus?.ticketStatusEnum == 2 ? 'status-primary' :
                        t.ticketStatusHistories?.[0]?.ticketStatus?.ticketStatusEnum == 3 ? 'status-success' :
                        t.ticketStatusHistories?.[0]?.ticketStatus?.ticketStatusEnum == 7 ? 'status-warning' : 'status-secondary'">
                      {{ t.ticketStatusHistories?.[0]?.ticketStatus?.title }}
                    </div>
                  </td>
                  <td>
                    <router-link :to="'/ticketDetails/' + t.id" class="btn btn-sm bg-gradient-primary td-button" title="جزئیات">
                      <fa-icon icon="fas fa-envelope-open" />
                    </router-link>
                    <button
                      v-if="listOf == 'submited' & (getPermission(1130).delete | !this.$store.state.currentUserInfo.isCompanyUser)"
                      class="btn btn-sm bg-gradient-danger mb-0 mt-0" @click="setTicket(t)" data-bs-toggle="modal"
                      data-bs-target="#warning" title="حذف">
                      <fa-icon icon="fas fa-trash" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :totalRecordCount="ticketList[0]?.totalCount ?? 0" :listPageSize="[10, 15, 20, 30, 50, 100]"
              :pageSize="pageSize" :pageIndex="pageIndex" @change-callback="updatePagination" />
            <hr class="horizontal dark" />
          </div>
          <div>
            <Router-link v-if="listOf == 'submited' & (getPermission(1130).insert | !this.$store.state.currentUserInfo.isCompanyUser)"
              class="btn bg-gradient-success mb-0" to="/submitTicket">
              ثبت تیکت جدید
            </Router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TicketService from "@/services/Ticket/Ticket-service.js";
import CompanyService from '@/services/Company/Company-service.js';
import UserService from '@/services/User/User-service.js';
import LabelService from "../../services/Ticket/LabelService";

import Treeselect from '@cholakovdev/vue3-treeselect';
import { mapGetters } from "vuex";
import { RouterLink } from "vue-router";

export default {
  components: { Treeselect },
  data() {
    return {
      ticketList: [],
      ticket: {},
      listOf: "",
      searchField: "",
      sections: [],
      selectedSections: [],
      importances: [
        { key: 0, value: 'پایین' },
        { key: 1, value: 'متوسط' },
        { key: 2, value: 'بالا' },
      ],
      selectedImportances: [],
      statuses: [
        { key: 0, value: 'دیده نشده' },
        // { key: 1, value: 'دیده شده' },
        { key: 2, value: 'درحال بررسی' },
        { key: 7, value: 'در انتظار پاسخ مشتری'},
        { key: 3, value: 'پاسخ داده شده' },
        { key: 4, value: 'بسته شده توسط کارشناس' },
        { key: 5, value: 'بسته شده توسط کاربر' },
        { key: 6, value: 'بسته شده توسط سیستم' },
      ],
      selectedStatuses: [],
      ticketLabels: [],
      selectedTicketLabels: [],
      treeselectKey: 0,
      customers: [],
      customerId: null,
      users: [],
      selectedUsers: [],
      fromDate: null,
      toDate: null,
      fromAnsweredDate: null,
      toAnsweredDate: null,
      isCompanyUser: false,
      isAdmin: false,
      tabs: [
        { key: 1, value: 'openTickets', },
        { key: 2, value: 'notSeenTickets', },
        // { key: 3, value: 'seenTickets', },
        { key: 4, value: 'inProgressTickets', },
        { key: 5, value: 'answeredTickets', },
        { key: 6, value: 'closedTickets', },
        { key: 9, value: 'CustomerResponsePendingTickets', },
      ],
      currentTab: { key: 1, value: 'openTickets', },
      componentCreated: false,
      filterVM: {},
      filtersAreActive: false,
      filtersAreOpen: false,
      pageSize: 20,
      pageIndex: 0,
      sortOptions: [
        { key: 0, value: 'ترتیب پیش فرض' },
        { key: 1, value: 'جدیدترین تیکت' },
      ],
      selectedSorting: 0,
    };
  },
  computed: {
    ...mapGetters(['getPermission']),
    notifications() {
      switch (this.listOf) {
        case "referred":
          return this.$store.getters.newReferralNotifications;

        case "submited":
          return this.$store.getters.myTicketsNotifications;

        case "bookmarked":
          return [...this.$store.getters.myTicketsNotifications, ...this.$store.getters.newReferralNotifications];
      }

      return [];
    },
  },
  watch: {
    selectedSorting() {
      this.updateRoute(this.currentTab.key, this.pageIndex, this.pageSize, this.selectedSorting);
    },
    customerId() {
      this.users = [];
      this.selectedUsers = [];
    },
    $route() {
      if (this.componentCreated) {
        this.setDataFromRoute();

        setTimeout(() => this.getTickets(), 200);
      }
    },
  },
  methods: {
    setFilterVM() {
      this.filterVM = {
        statusEnums: this.selectedStatuses.map(x => x.key).toString(),
        importanceEnums: this.selectedImportances.map(x => x.key).toString(),
        companySectionIds: this.selectedSections.map(x => x.id).toString(),
        searchString: this.searchField,
        fromCreateDate: this.fromDate,
        toCreateDate: this.toDate,
        fromAnsweredDate: this.fromAnsweredDate,
        toAnsweredDate: this.toAnsweredDate,
        customerId: this.customerId,
        ticketUserIds: this.selectedUsers.map(x => x.id).toString(),
        ticketLabelIds: this.selectedTicketLabels.map(x => x.id).toString(),
      };
    },
    activateFilters() {
      this.filtersAreActive = true;

      this.$store.dispatch('setTicketFilters', {
        selectedStatuses: this.selectedStatuses,
        selectedImportances: this.selectedImportances,
        selectedSections: this.selectedSections,
        searchField: this.searchField,
        fromDate: this.fromDate,
        toDate: this.toDate,
        fromAnsweredDate: this.fromAnsweredDate,
        toAnsweredDate: this.toAnsweredDate,
        customerId: this.customerId,
        selectedUsers: this.selectedUsers,
        selectedTicketLabels: this.selectedTicketLabels
      });

      this.setFilterVM();

      if (this.pageIndex != 0) {
        this.updateRoute(this.currentTab.key, 0, this.pageSize, this.selectedSorting);
      }
      else {
        setTimeout(() => this.getTickets(), 200);
      }
    },
    deactivateFilters() {
      this.filtersAreActive = false;

      this.$store.dispatch('resetTicketFilters');

      if (this.pageIndex != 0) {
        this.updateRoute(this.currentTab.key, 0, this.pageSize, this.selectedSorting);
      }
      else {
        setTimeout(() => this.getTickets(), 200);
      }
    },
    clearFilters() {
      this.filterVM = {};

      this.selectedImportances = [];
      this.selectedSections = [];
      this.selectedStatuses = [];
      this.searchField = null;
      this.fromDate = null;
      this.toDate = null;
      this.fromAnsweredDate = null;
      this.toAnsweredDate = null;
      this.customerId = null;
      this.treeselectKey++;
      this.selectedTicketLabels = [];

      if (this.filtersAreActive) {
        this.deactivateFilters();
      }
    },
    getTickets() {
      let filterVM = this.filtersAreActive ? { ...this.filterVM } : {};

      filterVM.pageIndex = this.pageIndex;
      filterVM.pageSize = this.pageSize;

      if ((filterVM?.statusEnums ?? '').length == 0) {
        filterVM.statusEnums = (this.currentTab?.key - 2).toString();

        switch (this.currentTab?.key) {
          case 1:
            filterVM.statusEnums = '0, 2, 7';
            break;

          case 6:
            filterVM.statusEnums = '4, 5, 6';
            break;
        }
      }

      this.ticketList = [];

      if (this.listOf == 'submited') {
        filterVM.orderByEnum = this.selectedSorting > 0 ? this.selectedSorting : (this.isCompanyUser ? 8 : 6);
        this.getUsersTickets(filterVM);
      }
      if (this.listOf == 'referred') {
        filterVM.orderByEnum = this.selectedSorting > 0 ? this.selectedSorting : 8;
        this.getTicketsReferredToUser(filterVM);
      }
      if (this.listOf == 'all') {
        filterVM.orderByEnum = 1;
        this.getAllTicketsOfOrganization(filterVM);
      }
      if (this.listOf == 'bookmarked') {
        filterVM.orderByEnum = this.selectedSections > 0 ? this.selectedSorting : 15;
        this.getBookmarkedTickets(filterVM);
      }
    },
    getUsersTickets(filterVM) {
      TicketService.getUsersTickets(filterVM).then(response => {
        let result = response.data;

        if (result.success) {
          this.ticketList = result.data.map(t => ({...t, isNew: (this.notifications.map(n => n.ticketId).indexOf(t.id) > -1)}));
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      })
    },
    getTicketsReferredToUser(filterVM) {
      TicketService.GetTicketsReferredToUser(filterVM).then(response => {
        let result = response.data;

        if (result.success) {
          this.ticketList = result.data.map(t => ({...t, isNew: (this.notifications.map(n => n.ticketId).indexOf(t.id) > -1)}));
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      })
    },
    getAllTicketsOfOrganization(filterVM) {
      TicketService.getAllTicketsOfOrganization(filterVM).then(response => {
        let result = response.data;

        if (result.success) {
          this.ticketList = result.data;
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      })
    },
    getBookmarkedTickets(filterVM) {
      TicketService.getBookmarkedTickets(filterVM).then(response => {
        let result = response.data;

        if (result.success)
          this.ticketList = result.data;
        else
          this.$toast.error(result.message);
      }).catch(e => {
        console.log(e);
      });
    },
    getCompanySections() {
      if (this.sections?.length > 0)
        return;

      let companyId = this.$store.state.currentUserInfo.companyId;
      let customerId = this.$store.state.currentUserInfo.customerId;

      if (this.isCompanyUser) {
        CompanyService.getSectionsForReferringByCompanyId(companyId).then(response => {
          let result = response.data;
          if (result.success) {
            this.sections = result.data;
          }
          else {
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
          this.$toast.error(e);
        });
      }
      else {
        CompanyService.getCompanySectionsForCustomer(companyId, customerId).then(response => {
          let result = response.data;
          if (result.success) {
            this.sections = result.data;
          }
          else {
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
          this.$toast.error(e);
        });
      }
    },
    getTicketLabels() {
      if (this.ticketLabels?.length > 0)
        return;

      LabelService.listCompanyLabels(false).then(response => {
        let result = response.data;

        if (result.success)
          this.ticketLabels = result.data;
        else
          this.$toast.error(result.message);
      }).catch(e => {
        console.log(e);
      });
    },
    setTicket(ticket) {
      this.ticket = ticket;
    },
    deleteTicket() {
      let deleteVM = { Id: this.ticket.id };

      TicketService.deleteTicket(deleteVM).then(response => {
        let result = response.data;

        if (result.success) {
          this.$toast.success(result.message);

          let index = this.ticketList.indexOf(this.ticket);

          if (this.ticketList.length > 1) {
            if (index == 0) {
              this.ticketList[1].totalCount = this.ticket.totalCount;
            }
            this.ticketList.splice(index, 1);
          }
          else {
            this.updateRoute(this.currentTab.key, this.pageIndex - 1, this.pageSize, this.selectedSorting);
          }
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getUsersByCustomer() {
      if (!this.customerId | this.users?.length > 0)
        return;

      UserService.getListByCustomerId(this.customerId).then(response => {
        let result = response.data;
        if (result.success) {
          this.users = result.data.map(user => ({ ...user, displayProp: (user.lastName + ' ' + user.firstName + ' - ' + user.postTitle) }));
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    changeTab(tabKey) {
      if (this.currentTab.key != tabKey) {

        if ((this.filterVM?.statusEnums ?? '').length > 0) {

          this.filterVM.statusEnums = '';
        }

        this.currentTab = this.tabs[this.tabs.map(x => x.key).indexOf(tabKey)];
        this.selectedStatuses = [];

        if (this.filtersAreActive) {
          this.$store.dispatch('setTicketFilters', { selectedStatuses: [] })
        }

        this.updateRoute(tabKey, 0, this.pageSize, this.selectedSorting);
      }
    },
    updatePagination(pageNumber, pageSize) {
      this.updateRoute(this.currentTab.key, pageNumber - 1, pageSize, this.selectedSorting);

      document.getElementById("tLTH").scrollIntoView();
    },
    setDataFromRoute() {
      this.currentTab = this.tabs[this.tabs.map(x => x.key).indexOf(parseInt(this.$route.query.tabKey ?? 1))];
      this.pageIndex = parseInt(this.$route.query.pageIndex ?? 0);
      this.pageSize = parseInt(this.$route.query.pageSize ?? 20);
      this.selectedSorting = parseInt(this.$route.query.sortKey ?? 0);
      this.listOf = this.$route.meta.listOf;

      let ticketFilters = this.$store.getters.getTicketFilters;

      if (ticketFilters) {
        this.filtersAreActive = true;
        this.filtersAreOpen = true;

        this.selectedStatuses = ticketFilters?.selectedStatuses ?? [];
        this.selectedImportances = ticketFilters?.selectedImportances ?? [];
        this.selectedSections = ticketFilters?.selectedSections ?? [];
        this.searchField = ticketFilters?.searchField;
        this.customerId = ticketFilters?.customerId;
        this.selectedUsers = ticketFilters?.selectedUsers ?? [];
        this.selectedTicketLabels = ticketFilters?.selectedTicketLabels ?? [];

        setTimeout(() => {
          this.fromDate = ticketFilters?.fromDate;
          this.toDate = ticketFilters?.toDate;
          this.fromAnsweredDate = ticketFilters?.fromAnsweredDate;
          this.toAnsweredDate = ticketFilters?.toAnsweredDate;
          this.setFilterVM();
        }, 100);
      }
    },
    updateRoute(tabKey, pageIndex, pageSize, sortKey) {
      if (this.listOf == 'submited') { this.$router.push({ path: '/myTickets', query: { tabKey, pageIndex, pageSize, sortKey } }); }
      if (this.listOf == 'referred') { this.$router.push({ path: '/referredTickets/', query: { tabKey, pageIndex, pageSize, sortKey } }); }
      if (this.listOf == 'all') { this.$router.push({ path: '/allTickets/', query: { tabKey, pageIndex, pageSize, sortKey } }); }
      if (this.listOf == 'bookmarked') { this.$router.push({ path: '/bookmarkedTickets/', query: { tabKey, pageIndex, pageSize, sortKey } }); }
    },
    ticketBookmarkToggle(ticketId) {
      TicketService.ticketBookmarkToggle(ticketId).then(response => {
        let result = response.data;

        if (result.success) {
          this.bookmarkChannel.postMessage({ ticketId });

          let index = this.ticketList.map(t => t.id).indexOf(ticketId);
          
          if (index > -1)
            this.ticketList[index].isBookmarked = !this.ticketList[index].isBookmarked;
        }
        else
         this.$toast.error(result.message);
      }).catch(e => {
        console.log(e);
      });
    }
  },
  created() {
    this.isCompanyUser = this.$store.state.currentUserInfo.isCompanyUser;
    this.isAdmin = this.$store.state.currentUserInfo.isAdmin;

    if (!this.$store.state.currentUserInfo.isCompanyUser & this.$store.state.currentUserInfo.isAdmin){
      this.customerId = this.$store.state.currentUserInfo.customerId;
    }

    this.setDataFromRoute();

    if (this.isCompanyUser) {
      this.customers = this.$store.state.currentUserInfo.customers;
    }

    setTimeout(() => this.getTickets(), 200);
    setTimeout(() => this.componentCreated = true, 200);
  },
  mounted() {
    this.bookmarkChannel = new BroadcastChannel('bookmarkToggle')

    this.bookmarkChannel.onmessage = ({ data }) => {
      const { ticketId } = data;
      
      let index = this.ticketList.map(t => t.id).indexOf(ticketId);
          
      if (index > -1)
        this.ticketList[index].isBookmarked = !this.ticketList[index].isBookmarked;
    }
  },
  beforeUnmount() {
    this.bookmarkChannel.close();
  }
}
</script>